import { useSelector } from 'react-redux'
import { InfoOutlined } from '@mui/icons-material'
import { preview } from '@/components/form/preview'
import { selectTerritory } from '@/features/domain/territory'
import { Tooltip } from '@/components/primitives/Tooltip'

import { useTexts } from '../../useTexts'
import { getCalculatedServiceTime } from './utils'

interface Props {
  extOrder: uui.domain.client.rm.ExtendedOrderStep
}

export function ServiceTime(props: Props) {
  const { extOrder } = props
  const texts = useTexts()
  const { rescheduleBehavior } = useSelector(selectTerritory)

  const trackingData = extOrder.orderStep.trackingData

  const infoIconWithTooltip = (
    <Tooltip title={texts.serviceTimeTooltip} placement="bottom">
      <InfoOutlined
        sx={{ fontSize: 20, display: 'flex', color: t => t.vars.palette.action.active }}
      />
    </Tooltip>
  )

  if (!trackingData) {
    return (
      <preview.Field
        label={texts.serviceTime.label}
        labelEndAdornment={infoIconWithTooltip}
        testId="execution-calculated-service-time"
      >
        <preview.NullValue />
      </preview.Field>
    )
  }

  const { timeDeltaSec } = getCalculatedServiceTime(trackingData, rescheduleBehavior)

  const minutes = timeDeltaSec > 0 ? Math.floor(Math.abs(timeDeltaSec) / 60) : 0

  return (
    <preview.Field
      label={texts.serviceTime.label}
      labelEndAdornment={infoIconWithTooltip}
      testId="execution-calculated-service-time"
    >
      {timeDeltaSec > 0 ? (
        <>{texts.serviceTimeValue(minutes)}</>
      ) : (
        <>{texts.noServiceTimeRecorded.label}</>
      )}
    </preview.Field>
  )
}
